import { toast } from 'sonner';

import { apiRequest } from '@/lib/api-client';

import { performInvoicePdfUpload } from '../lib/invoice-pdf-upload';
import type { InvoiceRow } from '../types';

async function uploadPdfBestEffort(invoiceId: string, pdfFile: File, verb: string): Promise<void> {
  try {
    await performInvoicePdfUpload(invoiceId, pdfFile, null);
  } catch {
    toast.error(`Invoice ${verb}, but the PDF upload failed — attach it from the edit dialog.`);
  }
}

// PATCH an existing invoice, or POST a new one; either way, a PDF handed over
// by the dialog (the create picker, or an AI extraction landing in an existing
// draft) uploads against the saved invoice. A failed upload never fails the
// save — the invoice is written and the PDF can be attached later from the
// edit dialog.
export async function saveInvoiceWithPdf(
  existingInvoice: InvoiceRow | null,
  payload: Record<string, unknown>,
  pdfFile: File | null,
): Promise<unknown> {
  if (existingInvoice !== null) {
    const updated = await apiRequest(`/invoices/${encodeURIComponent(existingInvoice.id)}`, {
      method: 'PATCH',
      body: payload,
    });
    if (pdfFile !== null) await uploadPdfBestEffort(existingInvoice.id, pdfFile, 'saved');
    return updated;
  }
  const created = await apiRequest<InvoiceRow>('/invoices', { method: 'POST', body: payload });
  if (pdfFile !== null) await uploadPdfBestEffort(created.id, pdfFile, 'created');
  return created;
}
